import { Link } from "react-router-dom";
import {
  ArrowRight,
  GraduationCap,
  Library,
  Search,
  Users,
} from "lucide-react";
import { Button } from "@jambushrushti/components/ui/button";

const stats = [
  { value: "10,000+", label: "Research Entries" },
  { value: "5,000+", label: "Manuscripts Indexed" },
  { value: "1,200+", label: "Scholars Connected" },
  { value: "50+", label: "Countries Reached" },
];

const services = [
  {
    icon: GraduationCap,
    title: "For Scholars",
    description: "Join our scholarly community and contribute to research",
    link: "/scholars",
    primary: true,
  },
  {
    icon: Library,
    title: "Library Access",
    description: "Browse our extensive catalog of Jain literature",
    link: "/library",
    primary: false,
  },
  {
    icon: Search,
    title: "AI Search",
    description: "Search inside texts with smart transliteration",
    link: "/research/shabdasangraha",
    primary: false,
  },
  {
    icon: Users,
    title: "Join Community",
    description: "Attend events and connect with like-minded seekers",
    link: "/community/events",
    primary: false,
  },
];

export function StatsAndServicesSection() {
  return (
    <section
      className="py-16 lg:py-20"
      style={{ background: "linear-gradient(to bottom, #FAF7F2, #F5EFE6)" }}
    >
      <div className="container mx-auto px-6">
        {/* Stats Row */}
        <div className="mb-14 grid grid-cols-2 gap-8 md:grid-cols-4">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div
                className="mb-2 text-3xl font-bold md:text-4xl lg:text-5xl"
                style={{
                  fontFamily: "Playfair Display, serif",
                  color: "#C9A227",
                }}
              >
                {stat.value}
              </div>
              <div
                className="text-sm md:text-base"
                style={{ fontFamily: "Inter, sans-serif", color: "#8B8680" }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Services Cards */}
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="rounded-xl border border-[#E8E4DD] bg-white p-6 transition-all duration-300 hover:shadow-lg"
            >
              <div
                className="mb-5 flex h-12 w-12 items-center justify-center rounded-lg"
                style={{ backgroundColor: "#FDF5E6" }}
              >
                <service.icon
                  className="h-6 w-6"
                  style={{ color: "#C9A227" }}
                />
              </div>
              <h3
                className="mb-2 text-lg font-semibold"
                style={{ fontFamily: "Inter, sans-serif", color: "#2D2A26" }}
              >
                {service.title}
              </h3>
              <p
                className="mb-5 text-sm leading-relaxed"
                style={{ fontFamily: "Inter, sans-serif", color: "#8B8680" }}
              >
                {service.description}
              </p>
              <Button
                asChild
                variant={service.primary ? "default" : "outline"}
                className={`w-full rounded-lg ${
                  service.primary
                    ? "text-white hover:opacity-90"
                    : "border-[#E8E4DD] hover:bg-[#F5EFE6]"
                }`}
                style={
                  service.primary
                    ? {
                        backgroundColor: "#C9A227",
                        fontFamily: "Inter, sans-serif",
                      }
                    : { fontFamily: "Inter, sans-serif", color: "#2D2A26" }
                }
              >
                <Link
                  to={service.link}
                  className="flex items-center justify-center gap-2"
                >
                  Get Started
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
